export default __webpack_public_path__ + "static/media/problema-04.536bd3e2.webp";